// extracted by mini-css-extract-plugin
module.exports = {"ul":"DataStream_ul__1_u-j","item":"DataStream_item__3Ph8M","vector":"DataStream_vector__3IUYG","label":"DataStream_label__3o-u6"};